import React from "react";
import TargetAchievementContainer from "../containers/TargetAchievement";
import { useLocation } from "react-router-dom";
import { log } from "node:console";
import TargetAchContainer from "../containers/TargetAchContainer";

const TargetAchievement = () => {
  const location = useLocation();
  const identifyPath = location?.state?.data;
  return (
    <>
      {identifyPath?.categories === "Target Achivement" ? (
        <TargetAchContainer location={location} identifyPath={identifyPath}/>
      ) : (
        <TargetAchievementContainer location={location} />
      )}
    </>
  );
};

export default TargetAchievement;
